import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutlined";
import CancelIcon from "@mui/icons-material/CancelOutlined";
import { Button, IconButton, Stack, TableCell, TableRow, Typography } from "@mui/material";
import { sortBy } from "lodash";
import { useState } from "react";
import type { ProductResponse } from "../../../admin/products/productsApi";
import type { ProviderProductType } from "../../../admin/providers/providersApi";
import { Select } from "../../../components/select/Select";
import type { InvoiceSellerId } from "../../../orders/ordersApi";
import { sellerByProductType } from "../../sellerByProductType";

interface Props {
  readonly details: ProductResponse | undefined;
  readonly existingOptionIds: string[];
  readonly hideInternalOptions: boolean;
  readonly onAdd: (option: { id: string }) => void;
}

export function AddOptionRow({ details, existingOptionIds, hideInternalOptions, onAdd }: Props) {
  const [isAdding, setIsAdding] = useState(false);

  const availableOptions = sortBy(details?.options ?? [], (o) => o.order)
    .filter((o) => !existingOptionIds.includes(o.id))
    .filter((o) => !hideInternalOptions || !o.internal)
    .map((o) => ({ value: o.id, label: o.name }));

  function handleCancel() {
    setIsAdding(false);
  }

  function handleOptionSelect(id: string) {
    onAdd({ id });
    setIsAdding(false);
  }

  if (isAdding) {
    return (
      <TableRow sx={{ verticalAlign: "middle" }}>
        <TableCell sx={{ borderBottom: "none", py: 1 }}>
          <Select
            label="Opcja"
            size="small"
            fullWidth
            value=""
            values={availableOptions}
            onSelect={handleOptionSelect}
          />
        </TableCell>
        <TableCell align="left" sx={{ borderBottom: "none", py: 1 }}>
          <IconButton size="small" sx={{ color: "text.secondary" }} onClick={handleCancel} title="Anuluj">
            <CancelIcon fontSize="small" />
          </IconButton>
        </TableCell>
        <TableCell colSpan={3} sx={{ borderBottom: "none", pt: 1, width: 40 }} align="right">
          <Seller provider={details?.provider} />
        </TableCell>
      </TableRow>
    );
  }

  return (
    <TableRow>
      <TableCell colSpan={5} sx={{ borderBottom: "none", py: 1 }}>
        <Stack
          direction="row"
          sx={{
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Button
            startIcon={<AddCircleOutlineIcon />}
            size="small"
            color="secondary"
            disabled={availableOptions.length === 0}
            onClick={() => setIsAdding(true)}
          >
            Dodaj opcję
          </Button>
          <Seller provider={details?.provider} />
        </Stack>
      </TableCell>
    </TableRow>
  );
}

function Seller(props: {
  provider?: {
    readonly productType?: ProviderProductType;
  };
}) {
  if (!props.provider?.productType) {
    return null;
  }
  return (
    <Typography
      variant="caption"
      sx={{
        color: "text.secondary",
      }}
    >
      Dostawca: <strong>{sellerLabel[sellerByProductType(props.provider?.productType)]}</strong>
    </Typography>
  );
}

const sellerLabel: Record<InvoiceSellerId, string> = {
  B2B_HOTELS: "B2Bhotels",
  PRZEZMORZE: "Przezmorze.pl",
};
